import { format } from 'date-fns';
import store from 'index';

import * as Util from 'PMDB/util/ConsumptionUtil.js';

import * as Mail from 'PMDB/util/MailUtil.js';

class MetadataOnSave {
    
    elements = {};

    constructor(elements = {}) {
        this.elements = { ...elements };
    }
    
    onCorrectModelConsumption = (changedElements) => {
		const merged = { ...this.elements, ...changedElements };
		const apiConsumptionModels = store.getState().ui.apiConsumptionModels;
		const apiConsumption = store.getState().ui.apiConsumption;
		const decoded = Util.decodeKDC(apiConsumptionModels, apiConsumption, /*merged.consumptiondatakeys*/merged.keyConsumptionData);
		const ids = (merged.modelle_ids && merged.modelle_ids.split(';')) || [];
		
		for(let id in decoded) {
			if(!ids.includes(id)) {
				delete decoded[id];
			}
		}
        
		/*changedElements.consumptiondatakeys*/changedElements.keyConsumptionData = Util.encodeKCD(decoded);
		
        return changedElements;
    }
    
    onPMStateChange = (changedElements) => {
        // need to set URLs automatically
        let metadata = {};
        //console.log(this.elements, changedElements);
        if(this.elements.hasOwnProperty("status") && changedElements.hasOwnProperty("status")) {
            //console.log(this.elements.published, changedElements.published);
            if(this.elements.status !== changedElements.status) {
                if(changedElements.status === "approved" || changedElements.status === "approved internal") {
                    console.log("---------Approved----------");
                    const merged = { ...this.elements, ...changedElements };
                    Mail.sendMail(merged);
                    
                    // set URLs if approved
                    metadata = {
                        url_en: "https://newsroom.porsche.com/en/pi/"+changedElements.id,
                        url_de: "https://newsroom.porsche.com/de/pi/"+changedElements.id
                    };
                }
            }
        }
        
        // remove id and lang after send
        delete changedElements.id;
        delete changedElements.lang;
        delete changedElements.email;
        
        return { ...changedElements, ...metadata };
    }
}

export default MetadataOnSave;


